/**
 * Waits the given amount of time.
 *
 * @param ms - Time to wait in milliseconds
 */
export function wait(ms: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

/**
 * Waits until the given timestamp.
 *
 * @param ts - Unix timestamp in milliseconds (e.g. `Date.now()`)
 */
export async function waitUntil(ts: number): Promise<void> {
  for (let now = Date.now(); ts > now; now = Date.now()) {
    await wait(ts - now);
  }
}
